import { Column, Row } from '../../../components/Grid';
import { HtmlContent } from '../../../components/layout/HtmlContent';
import { CType } from '../../../provider/Typo3Provider/types';
import { Title } from '../../../components/Title';
import { Subtitle } from '../../../components/Subtitle';
import { Image } from '../../../components/Image';
import { ButtonAnchor } from '../../../components/Button';
import { NewsletterTeaser } from '../../../components/NewsletterTeaser';

interface ButtonProps {
    button_link: string;
    button_text: string;
}

const NewsletterTeaserContainer = ({ bodytext = '', header, subheader, files, button_link, button_text }: CType & ButtonProps) => {
    const images = files?.image || [];
    return (
        <NewsletterTeaser>
            <Row bg='grayLight'>
                <Column large={9} medium={7} small={12} >
                    <Title.H2 align='left'>{header}</Title.H2>
                    {subheader && <Subtitle.H2 align='left'>{subheader}</Subtitle.H2>}
                    <HtmlContent htmlString={bodytext} />
                    <ButtonAnchor primary large href={button_link}>
                        {button_text}
                    </ButtonAnchor>
                </Column>
                { <Column large={3}>
                    <Row noGap>
                        <Column large={4} />
                        <Column large={8} bg='secondary' />
                        {images[0] && <Image src={images[0].imageUri} alt={images[0].name} />}
                    </Row>
                </Column>}
            </Row>
        </NewsletterTeaser>
    );
}

export default NewsletterTeaserContainer;
